// extracted by mini-css-extract-plugin
module.exports = {"container":"AppPage_container__2_zav"};